import React from "react";
import { FaSearch, FaSync, FaTimes } from "react-icons/fa";

export default function UserVoteFilters({
  filters,
  setFilters,
  loading,
  total,
  count,
  onRefresh,
}) {
  const update = (patch) => {
    setFilters((previous) => ({
      ...previous,
      ...patch,
    }));
  };

  const reset = () => {
    setFilters({
      search: "",
      type: "all",
      status: "available",
    });
  };

  const fieldClass =
    "w-full rounded-2xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none transition focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-white dark:focus:ring-indigo-900/30";

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-5 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Filtres
            </p>

            <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
              Rechercher une consultation
            </h2>

            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
              {count} affiché{count > 1 ? "s" : ""} sur {total}.
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={reset}
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-2xl bg-slate-100 px-4 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-200 disabled:opacity-60 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
            >
              <FaTimes />
              Réinitialiser
            </button>

            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-3 text-sm font-bold text-white transition hover:bg-indigo-800 disabled:opacity-60"
            >
              <FaSync className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Recherche
            </label>

            <div className="relative">
              <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

              <input
                type="text"
                value={filters.search}
                onChange={(event) => update({ search: event.target.value })}
                disabled={loading}
                placeholder="Titre, description, type..."
                className={`${fieldClass} pl-9`}
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Type
            </label>

            <select
              value={filters.type}
              onChange={(event) => update({ type: event.target.value })}
              disabled={loading}
              className={fieldClass}
            >
              <option value="all">Tous les types</option>
              <option value="vote">Votes</option>
              <option value="sondage">Sondages</option>
            </select>
          </div>

          <div className="lg:col-span-3">
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Statut
            </label>

            <select
              value={filters.status}
              onChange={(event) => update({ status: event.target.value })}
              disabled={loading}
              className={fieldClass}
            >
              <option value="available">À répondre</option>
              <option value="answered">Déjà répondus</option>
              <option value="upcoming">Programmés</option>
              <option value="closed">Clôturés</option>
              <option value="all">Tout afficher</option>
            </select>
          </div>
        </div>
      </div>
    </section>
  );
}